"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputFieldSet = _interopRequireDefault(require("../InputFieldSet"));

var _InputField = _interopRequireDefault(require("../InputField"));

var _Input = _interopRequireDefault(require("../Input"));

var _InlineButtonPanel = _interopRequireDefault(require("../InlineButtonPanel"));

var _AnchorLink = _interopRequireDefault(require("../AnchorLink"));

var _Button = _interopRequireDefault(require("../Button"));

var _suiteLinks = require("../../constants/suiteLinks");

var _stylingUtils = require("../../services/stylingUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var getClassName = function getClassName(props) {
  return (0, _stylingUtils.getClassNames)(props.className, {
    "rhe-login-form": true
  });
};

var LoginForm = function LoginForm(_ref) {
  var className = _ref.className,
      email = _ref.email,
      password = _ref.password,
      redirect = _ref.redirect,
      redirectUrl = _ref.redirectUrl,
      onSubmit = _ref.onSubmit,
      submitButton = _ref.submitButton,
      forgottenPasswordLink = _ref.forgottenPasswordLink,
      showCreateAccountLink = _ref.showCreateAccountLink,
      createAccountLink = _ref.createAccountLink;
  return _react.default.createElement("div", {
    className: getClassName({
      className: className
    })
  }, _react.default.createElement("form", {
    onSubmit: onSubmit
  }, _react.default.createElement("div", null, _react.default.createElement(_InputFieldSet.default, {
    className: "rhe-login-form__inputs"
  }, _react.default.createElement(_InputField.default, _extends({
    placeholder: "Your email address"
  }, email), "Email"), _react.default.createElement(_InputField.default, _extends({
    type: "password",
    placeholder: "Your password"
  }, password), "Password"), _react.default.createElement(_Input.default, _extends({}, redirect, {
    type: "hidden",
    value: redirectUrl
  }))), _react.default.createElement(_AnchorLink.default, _extends({
    className: "button-panel__forgotten-password"
  }, forgottenPasswordLink), "Forgotten your password?")), _react.default.createElement(_InlineButtonPanel.default, {
    className: "rhe-login-form__button-panel"
  }, _react.default.createElement(_Button.default, _extends({
    className: "rhe-login-form__sign-in-button"
  }, submitButton), "Sign in"))), showCreateAccountLink && _react.default.createElement("div", {
    className: "rhe-login-form__create-container"
  }, _react.default.createElement("span", {
    className: "create-container__divider"
  }), _react.default.createElement("span", {
    className: "create-container__content"
  }, "Not yet registered? ", _react.default.createElement(_AnchorLink.default, createAccountLink, "Create an account"), " to get started.")));
};

LoginForm.defaultProps = {
  email: {},
  password: {},
  redirect: {},
  onSubmit: function onSubmit() {},
  submitButton: {},
  forgottenPasswordLink: {
    onClick: function onClick() {
      return window.open(_suiteLinks.SSO_URL + '/forgotten-password', '_blank');
    }
  },
  showCreateAccountLink: true,
  createAccountLink: {
    onClick: function onClick() {
      return window.open(_suiteLinks.SSO_URL + '/register', '_blank');
    }
  }
};
LoginForm.propTypes = {
  className: _propTypes.default.string,
  email: _propTypes.default.object,
  password: _propTypes.default.object,
  redirect: _propTypes.default.object,
  onSubmit: _propTypes.default.func,
  redirectUrl: _propTypes.default.string,
  submitButton: _propTypes.default.object,
  showCreateAccountLink: _propTypes.default.bool,
  createAccountLink: _propTypes.default.object
};
var _default = LoginForm;
exports.default = _default;